<template>
  <div class="flex flex-col">
    <!-- CONFIRM WHICH TO SUBMIT -->
    <h1 class="w-full mt-12 mb-6 mx-auto font-medium">
      You have edited {{ numOtherEdited }} other site{{ numOtherEdited === 1 ? "" : "s" }}. 
      Would you like to save {{ numOtherEdited === 1 ? "it" : "them" }} as well?
    </h1>
    <div
      class="w-full flex flex-col-reverse sm:flex-row flex-wrap sm:flex-nowrap justify-evenly my-8"
    >
      <VButton
        label="No, just this one"
        @click="saveOne"
        outlined uppercase class="w-full sm:w-5/12"
      />
      <VButton
        label="Yes, save them"
        @click="saveMultiple"
        uppercase class="w-full mb-2 sm:mb-0 sm:w-5/12"
      />
    </div>
  </div>
</template>

<script>
import VButton from "@/components/Buttons/Button/VButton.vue"
import { mapGetters, mapMutations } from "vuex"

export default {
  components: {
    VButton,
  },
  computed: {
    ...mapGetters(["getProceedArgs", "getEmployeesSitesEdited"]),
    singleEmployee() {
      return this.getProceedArgs[0]
    },
    numOtherEdited() {
      return Object.keys(this.getEmployeesSitesEdited).length - 1
    },
  },
  methods: {
    ...mapMutations([
      "setProceedArgs",
      "setEmployeesToUpdate",
      "closePrompt"
    ]),
    saveOne() {
      this.setEmployeesToUpdate({ [this.singleEmployee.site_id]: this.singleEmployee })
      this.closePrompt()
    },
    saveMultiple() {
      this.setEmployeesToUpdate(this.getEmployeesSitesEdited)
      this.closePrompt()
    }
  },
}
</script>